class Password {
    static regexs: Array<RegExp> = [/\d+/, /[a-z]/, /[A-Z]/, /.{8,36}/, /\W|_/];

    static GetStrength = (value: any): number => {
        let score:number = 0;

        for (let r of Password.regexs)
            if (r.test(value))
                score++;

        return score;
    }
}

export default Password;